<template>
  <div class="rank-list">
    <div class="top_detail" v-if="user.nick_name">
      <van-image
        class="backgroundImage"
        fit="cover"
        :src="require('@/assets/img/personal-header.png')"
      />
      <div class="detail_box">
        <van-image class="header" fit="cover" round :src="user.head" />
        <span class="name">{{ user.nick_name }} </span>
      </div>
      <div class="briefIntroduction">
        {{ user.personal_profile }}
        <div class="edit-btn-box" v-if="user.personal_profile">
          <span class="edit-btn" @click="introduction">修改</span>
        </div>
        <div v-if="!user.personal_profile" class="un-sub">
          <div class="un-sub-left">
            <van-icon name="edit" size="20px" />填写个人简介
          </div>
          <div class="un-sub-right" @click="introduction">去填写</div>
        </div>
      </div>
    </div>
    <CommentList @setUser="setUser" :unPersonal="false" />
    <IntroductionForm
      v-if="loading"
      v-model:show="showIntroductionForm"
      :content="user.personal_profile"
      @setContent="setContent"
    />
  </div>
</template>
<script setup>
//引入vant Popup
import { Image as VanImage, Icon as VanIcon } from "vant";
import { ref } from "vue";
import CommentList from "../components/CommentList.vue";
import IntroductionForm from "@/components/IntroductionForm.vue";

const showIntroductionForm = ref(false);
const loading = ref(false);
const introduction = () => {
  showIntroductionForm.value = true;
};
//更新用户信息
const user = ref({});
const setUser = (data) => {
  console.log("setUser", data);
  user.value = data;
  loading.value = true;
};

const setContent = (data) => {
  user.value.personal_profile = data;
};
</script>
<style lang="scss" scoped>
.rank-list {
  background-color: #fff;
  height: 100vh;
  overflow: scroll;
}

.top_detail {
  position: relative;
  margin-bottom: 20px;
  padding-top: 140px;
  .backgroundImage {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 179px;
  }
  .detail_box {
    position: absolute;
    left: 0;
    top: 26px;
    width: 100%;
    display: flex;
    flex-direction: column;
    .header {
      width: 76px;
      height: 76px;
      border: 2px solid #fff;
      margin: 0 auto;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
      margin-bottom: 7px;
    }
    .name {
      font-size: 16px;
      font-weight: 700;
      color: #fff;
    }
  }

  .briefIntroduction {
    padding: 18px 24px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    margin: 0 16px;
    font-size: 14px;
    line-height: 1.5;
    border-radius: 6px;
    text-align: left;
    position: relative;
    z-index: 1;
    color: #c0c4cc;
    .edit-btn-box {
      text-align: center;
      margin-top: 10px;
    }
    .edit-btn {
      display: inline-block;
      background-color: #ffe5e3;
      font-size: 12px;
      color: #ff5c5c;
      height: 20px;
      line-height: 20px;
      padding: 0 10px;
    }
  }
}
.un-sub {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .un-sub-left {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #c0c4cc;
    .van-icon {
      margin-right: 5px;
    }
  }
  .un-sub-right {
    font-size: 12px;
    color: #ff5c5c;
    background: #ffe5e3;
    height: 20px;
    line-height: 20px;
    padding: 0 4px;
  }
}
</style>
